export interface IAgency {
  disableAgency: boolean;
  productEmail: string;
  salesEmail: string;
  logoUrl: string;
  defaultAgency: boolean;
  createdAt: string;
  supportEmail: string;
  deleted: boolean;
  customerExperienceEmail: string;
  name: string;
  poweredByText: string;
  accountingEmail: string;
  id: number;
  updatedAt: string;
}

export interface IPublicBusinessConfig {
  getTwilioNumber: boolean;
  notificationSMSNumber: string;
  contactSupportEmail: string;
  aestheticSpecialization: boolean;
  paidMediaReportEmail: string;
  paymentRefundable: boolean;
  enableSmsAutoReply: boolean;
  googleAnalyticsGlobalCodeUrl: string;
  syndicationCode: string | null;
  subDomainName: string;
  twilioNumber: string | null;
  subDomainWebsiteTemplateId: number;
  termsAndConditions: string;
  landingPageTrackCode: string;
  countryCode: string;
  syndicationReportEmail: string;
  paymentRefundableBeforeHours: number;
  paidMediaCode: string;
  id: number;
  lastNotifyDateTime: string | null;
  enableTwoWaySMS: boolean;
  dentalSpecializationOnly: boolean;
  enableEmailNotificationForMessages: boolean;
  agency: IAgency;
  privacyPolicy: string;
  notifyAfterMinute: number;
  seoCode: string | null;
  notificationEmail: string;
  upgradeToTwoWayText: boolean;
  logoUrl: string;
  smsLimit: number;
  dataStudioCode: string;
  dashboardAndReportEmail: string;
  showPatientDetailsOnSinglePage: boolean;
  performanceScoreCard: string | null;
  deleted: boolean;
  showNotesPopupOnLeadLoad: boolean;
  trainingBusiness: boolean;
  emailLimit: number;
  enableAiTwoWaySMSSuggestion: boolean;
  name: string;
  refundablePaymentPercentage: number;
  poweredByText: string;
  googleAnalyticsGlobalCode: string;
  defaultClinicId: number;
  chatBotQuestionnaireId: number;
  A2pSetUp: TwoWayTextSetupStatus;
  statusAutomationEnabled: boolean;
  isAiResponderEnabled: boolean;
  giaPurchased: boolean | null;
  giaDemoFormSubmitted: boolean | null;
  /** Optional here — only sent as a PATCH payload to the business-config API. */
  isAICampaignEnabled?: boolean;
}

export interface IBusinessProfile {
  name: string;
  trainingBusiness: boolean;
  subDomainName: string;
  businessDomain?: string;
  showNotesPopupOnLeadLoad: boolean;
  showPatientDetailsOnSinglePage: boolean;
  paymentRefundable: boolean;
  refundablePaymentPercentage: number;
  paymentRefundableBeforeHours: number;
  landingPageTrackCode: string;
  googleAnalyticsGlobalCode: string;
  googleAnalyticsGlobalCodeUrl: string;
  logoUrl: string;
  logoFile: Blob | null;
  twilioNumber: string;
  notificationEmail?: string;
  enableTwoWaySMS?: boolean;
}

export interface IBusinessInfo {
  [key: string]: any;
  id: string;
  name?: string;
}

export enum TwoWayTextSetupStatus {
  SETUP_PENDING = 'SETUP_PENDING',
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  APPROVAL_DONE = 'APPROVAL_DONE',
  BRAND_FAILED = 'BRAND_FAILED',
  CAMPAIGN_FAILED = 'CAMPAIGN_FAILED',
}

export type MigrationStatus = 'pending' | 'in-progress' | 'done' | 'failed';

export interface IBusinessConfigFlags {
  id: number;
  isAiResponderEnabled: boolean;
  isFetchingAllowed: boolean;
  isMigrationDone: boolean;
  isNewUIEnabled: boolean;
  migrationStatus: MigrationStatus;
  showReviewPlatforms: boolean;
  statusAutomationEnabled: boolean;
  tenantId: number;
  showGiaMenu: boolean;
  isTwowayTextValidationEnabledForGiaActivation: boolean;
  isAppointmentEnabled: boolean;
  /** When true (and Gia is active) the Automation tab shows AI Campaign instead of Trigger. */
  isAICampaignEnabled: boolean;
}
